import React from 'react';
import styled from 'styled-components';
import {
  GroupTitleSkeleton,
  PipelineCardSkeleton,
  StatStripSkeleton
} from './blocks';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const GroupSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 14px;
`;

interface IPipelineGridSkeletonProps {
  groups?: number;
  cardsPerGroup?: number;
}

const PipelineGridSkeleton: React.FC<IPipelineGridSkeletonProps> = ({
  groups = 4,
  cardsPerGroup = 4
}) => (
  <Wrapper>
    <StatStripSkeleton tiles={4} />
    {Array.from({ length: groups }).map((_, gi) => (
      <GroupSection key={gi}>
        <GroupTitleSkeleton />
        <Grid>
          {Array.from({ length: cardsPerGroup }).map((__, ci) => (
            <PipelineCardSkeleton key={ci} />
          ))}
        </Grid>
      </GroupSection>
    ))}
  </Wrapper>
);

export default PipelineGridSkeleton;
